export default __webpack_public_path__ + "static/media/intersec.9c55c29c.jpg";